import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "./Navbar.css";
import { useAppData } from "../../Data/BackEnd Data/FetchBackEndData";
import { phoneNumber } from "../../Data/BrandData";

export default function Navbar() {
  const [menu, setMenu] = useState(false);
  const [sticky, setSticky] = useState(false);
  const { pathname, hash } = useLocation();

  const { refreshWebsiteData } = useAppData();

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll);
    refreshWebsiteData();
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);

      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 0);

        return;
      }
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [pathname, hash]);

  const handleLinkClick = () => {
    const navbarToggler = document.querySelector(".mobile-btn");
    if (window.innerWidth <= 991 && menu) {
      navbarToggler.click();
    }
  };

  return (
    <>
      <header className={sticky ? "navbar-area sticky" : "navbar-area"}>
        <div className="container">
          <nav className="navbar-main">
            <Link to="/" className="logo">
              <img
                src={require("./../../Assets/NexGen_Web_Designs_Finla_Light_Logo_With_Background.png")}
                alt="NexGen Web Designs"
              />
            </Link>

            <ul className={menu ? "nav-links active" : "nav-links"}>
              <h3 className="navbar-brand-name">NexGen Web Designs</h3>
              <li>
                <NavLink to="/" onClick={handleLinkClick}>
                  Home
                </NavLink>
              </li>

              <li>
                <NavLink to="/about" onClick={handleLinkClick}>
                  About
                </NavLink>
              </li>

              <li>
                <NavLink to="/services" onClick={handleLinkClick}>
                  Services
                </NavLink>
              </li>

              <li>
                <NavLink to="/portfolio" onClick={handleLinkClick}>
                  Portfolio
                </NavLink>
              </li>

              <li>
                <NavLink to="/pricing" onClick={handleLinkClick}>
                  Pricing
                </NavLink>
              </li>

              <li>
                <NavLink to="/careers" onClick={handleLinkClick}>
                  Careers
                </NavLink>
              </li>

              <li>
                <NavLink to="/contact" onClick={handleLinkClick}>
                  Contact
                </NavLink>
              </li>
            </ul>

            <Link
              to={`tel:${phoneNumber}`}
              className="contact-btn"
              style={{ textWrap: "nowrap" }}
            >
              Let's Talk <i className="fa-solid fa-arrow-right-long ms-3"></i>
            </Link>

            <button className="mobile-btn" onClick={() => setMenu(!menu)}>
              {menu ? (
                <i className="fa-solid fa-xmark"></i>
              ) : (
                <i className="fa-solid fa-bars"></i>
              )}
            </button>
          </nav>
        </div>
      </header>
    </>
  );
}
